import { Box } from '@mui/material';
import { FC, ReactElement } from 'react';

import markAnyLfsLogo from '@assets/images/markAnyLfsLogo.svg';

const AuthHeader: FC = (): ReactElement => {
  return (
    <header>
      <Box
        display="flex"
        justifyContent="flex-start"
        padding="10px 74px"
        bgcolor="var(--base-white)"
        borderBottom="1px solid var(--neutral-700)"
        height="60px"
      >
        <Box>
          <img src={markAnyLfsLogo} alt="MarkAny LFS" width={216} height={38} />
        </Box>
      </Box>
    </header>
  );
};

export default AuthHeader;
